import { render, staticRenderFns } from "./AddFileButton.vue?vue&type=template&id=07c4437f&scoped=true&"
import script from "./AddFileButton.vue?vue&type=script&lang=js&"
export * from "./AddFileButton.vue?vue&type=script&lang=js&"
import style0 from "./AddFileButton.vue?vue&type=style&index=0&id=07c4437f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c4437f",
  null
  
)

export default component.exports